/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

const USER_TOPIC_PREFIX = 'user-';

export const AUTHORIZATION_HEADER_KEY = 'X-Authorization';

export const WS_CONNECTION_PARAMS = {
  reconnectDelay: 15000,
  connectionTimeout: 60000,
  heartbeatIncoming: 40000,
  heartbeatOutgoing: 40000,
};

/**
 * For direct user messages we use the convention of topics that start with the 'user-' prefix.
 */
export const buildSubscriptionPath = (tenantId, topic) => {
  return isUserTopic(topic) ? `/user/tenant/${tenantId}/topic/${topic}` : `/tenant/${tenantId}/topic/${topic}`;
};

const isUserTopic = topic => topic.startsWith(USER_TOPIC_PREFIX);
